enum PermissionName {
  EXPORT_CREATE = "reports:c", // creating new exports
  EXPORT_UPDATE = "reports:u", // updating exports
  EXPORT_DELETE = "reports:d", // deleting exports
  EXPORT_DOWNLOAD = "reports:ex", // downloading exports
  EXPORT_READ = "reports:r", // reading list of exports
}

export default PermissionName;
